import { HomePage } from "pages/home/index2";
import PartnerForm from "pages/partner";
import { createBrowserRouter } from "react-router-dom";

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <HomePage />,
    },
    {
      path: "/revenda",
      element: <PartnerForm />,
    },
  ],
  {
    basename: process.env.PUBLIC_URL,
  }
);

export default router;
